import { Col, Row, Modal, Form, Switch, Button, message } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Title from "../UI/Title/Title";
import { ItemsType } from "./itemsType";
import { editCompose, getItemsById } from "../../api/itemapi";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { Dispatch, useEffect, useState } from "react";
import { AxiosResponse } from "axios";

type propsType = {
  openComponent: boolean;
  setOpenComponent: React.Dispatch<React.SetStateAction<boolean>>;
  id: any;
  isComposed: boolean;
  ItemsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    {
      limit: number;
      q: string;
      isActive?: boolean | undefined;
      isChild: boolean;
    },
    unknown
  >;
  filter: boolean | undefined;
  search: any;
  setPaginatedItems: Dispatch<any>;
  loadingcategory: boolean;
  formatedcategory: {}[] | undefined;
  formatedItemUnit: {}[] | undefined;
  loadingItemUnit: boolean;
  formatedBrand: {}[] | undefined;
  loadingBrand: boolean;
  formatedSupplier: {}[] | undefined;
  loadingSupplier: boolean;
  formatedPriceScheme: {}[] | undefined;
  loadingPriceScheme: boolean;
  page: number;
};
export const ComponentModal = ({
  openComponent,
  setOpenComponent,
  id,
  isComposed,
  ItemsMutation,
  search,
  filter,
  setPaginatedItems,
  loadingcategory,
  formatedcategory,
  formatedItemUnit,
  loadingItemUnit,
  formatedBrand,
  loadingBrand,
  formatedSupplier,
  loadingSupplier,
  formatedPriceScheme,
  loadingPriceScheme,
  page,
}: propsType) => {
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const getItemsMutation = useMutation("getItems", getItemsById);
  function fillItemById(id: any, key: string) {
    getItemsMutation.mutateAsync(id).then((res) => {
      navigate(`/item/${id}`, {
        state: {
          item: res.data,
          formatedcategory: formatedcategory,
          loadingcategory: loadingcategory,
          formatedBrand: formatedBrand,
          loadingBrand: loadingBrand,
          formatedItemUnit: formatedItemUnit,
          loadingItemUnit: loadingItemUnit,
          formatedPriceScheme: formatedPriceScheme,
          loadingPriceScheme: loadingPriceScheme,
          formatedSupplier: formatedSupplier,
          loadingSupplier: loadingSupplier,
          key: key,
        },
      });
    });
  }

  const { mutate: mutateEdit, isLoading: isSaving } = useMutation(
    "editcomponents",
    (component: ItemsType) => editCompose(id, component),
    {
      onSuccess: (res) => {
        message.success("Saved successfully!");
        ItemsMutation({
          q: search,
          isActive: filter,
          limit: page * 10 + 10,
          isChild: false,
        }).then((res: any) => {
          setPaginatedItems(res.data?.data);
        });
        setOpenComponent(false);
        if (isComposedSwitch) {
          fillItemById(id, "3");
        }
        setShouldRefresh(true);
      },
    }
  );
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const handleFinish = () => {
    const newBrand = form.getFieldsValue();
    for (const key in newBrand) {
      if (newBrand[key] === undefined) {
        if (key === "isComposed") {
          newBrand[key] = isComposedSwitch;
        } else {
          newBrand[key] = null;
        }
      }
    }
    if (newBrand.isComposed !== isComposed) {
      mutateEdit(newBrand);
    } else {
      setOpenComponent(false);
      if (isComposedSwitch) {
        fillItemById(id, "3");
      }
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      isComposed: isComposed,
    });
  }, [isComposed, form, shouldRefresh]);
  useEffect(() => {
    if (shouldRefresh) {
      setShouldRefresh(false);
    }
  }, [shouldRefresh]);
  const [isComposedSwitch, setIsComposedSwitch] = useState(isComposed);
  return (
    <>
      <Modal
        data-testid="modal"
        closable={false}
        maskClosable={false}
        centered
        width={400}
        onCancel={() => setOpenComponent(false)}
        open={openComponent}
        cancelText={t("cancel")}
        okText={`${t("save")}`}
        footer={[
          <Button
            key="cancel-button"
            onClick={() => setOpenComponent(false)}
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              marginInlineEnd: "auto",
              width: "100px",
              height: "40px",
            }}
          >{`${t("cancel")}`}</Button>,
          <Button
            key="confirm-button"
            form="composeForm"
            htmlType="submit"
            style={{
              background: "#1677FF",
              color: "#fff",
              height: "40px",
              border: "none",
              width: "100px",
            }}
            disabled={isSaving}
          >
            {isSaving ? `${t("loading")}` : `${t("save")}`}
          </Button>,
        ]}
      >
        <Form
          data-testid="form"
          layout="vertical"
          form={form}
          id="composeForm"
          onFinish={handleFinish}
        >
          <Row>
            <Col>
              <Title title={`${t("item-component")}`} />
              {`${t("are-you-sure-you-want-to-edit-component-?")}`}

              <Col style={{ marginTop: "10px" }}>
                {" "}
                <Form.Item
                  label={`${t("composed")}`}
                  name="isComposed"
                  valuePropName="checked"
                >
                  <Switch
                    checked={isComposedSwitch}
                    onChange={(checked) => setIsComposedSwitch(checked)}
                    checkedChildren={`${t("yes")}`}
                    unCheckedChildren={`${t("no")}`}
                  />
                </Form.Item>
              </Col>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
